class SMGVideoInstructions extends HTMLElement {
  connectedCallback() {
    /** @type {HTMLVideoElement | null} */
    this.video = this.querySelector('video[data-src]');

    if (!this.video) return;

    /** @type {HTMLButtonElement | null} */
    this.playBtn = this.querySelector('[data-action="play-pause"]');
    /** @type {HTMLButtonElement | null} */
    this.muteBtn = this.querySelector('[data-action="mute"]');

    this.playIcon     = this.playBtn?.querySelector('.smg-video-instructions__icon--play');
    this.pauseIcon    = this.playBtn?.querySelector('.smg-video-instructions__icon--pause');
    this.soundOnIcon  = this.muteBtn?.querySelector('.smg-video-instructions__icon--sound-on');
    this.soundOffIcon = this.muteBtn?.querySelector('.smg-video-instructions__icon--sound-off');

    this.lazyLoad();
    this.bindControls();
  }


  lazyLoad() {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || !this.video) return;

          const src = this.video.dataset.src;
          if (src) {
            this.video.src = src;
            delete this.video.dataset.src;
            this.video.load();
            this.video.play().catch(() => {});
          }

          obs.disconnect();
        });
      },
      { rootMargin: '0px 0px 200px 0px' }
    );

    observer.observe(this);
  }

  bindControls() {
    this.playBtn?.addEventListener('click', () => this.togglePlay());
    this.muteBtn?.addEventListener('click', () => this.toggleMute());

    this.video?.addEventListener('play',  () => this.updatePlayIcon(true));
    this.video?.addEventListener('pause', () => this.updatePlayIcon(false));
  }

  togglePlay() {
    if (!this.video) return;

    if (this.video.paused) {
      this.video.dataset.manualPause = 'false';
      this.video.play();
    } else {
      this.video.dataset.manualPause = 'true';
      this.video.pause();
    }
  }

  toggleMute() {
    if (!this.video) return;

    this.video.muted = !this.video.muted;
    this.updateMuteIcon();
  }

  /** @param {boolean} isPlaying */
  updatePlayIcon(isPlaying) {
    this.playIcon?.toggleAttribute('hidden', isPlaying);
    this.pauseIcon?.toggleAttribute('hidden', !isPlaying);
    this.playBtn?.setAttribute('aria-label', isPlaying ? 'Pausar video' : 'Reproducir video');
  }

  updateMuteIcon() {
    if (!this.video) return;
    this.soundOffIcon?.toggleAttribute('hidden', !this.video.muted);
    this.soundOnIcon?.toggleAttribute('hidden', this.video.muted);
    this.muteBtn?.setAttribute('aria-label', this.video.muted ? 'Activar sonido' : 'Silenciar video');
  }
}

customElements.define('smg-video-instructions', SMGVideoInstructions);
